import { persistStore } from 'redux-persist';

import store from './store';

// Legacy guidedTour → tours migration runs in <TourLegacyMigration> after sessionChecked,
// not here — we need the logged-in userId before seeding progress.
// TODO(sc-6875): After one release, remove TourLegacyMigration and guidedTour persist entirely.
const persistor = persistStore(store);

export default persistor;
